import { render } from "./Base.vue?vue&type=template&id=e6a7dff4"
import script from "./Base.ts?vue&type=script&lang=js"
export * from "./Base.ts?vue&type=script&lang=js"

import "./Base.vue?vue&type=style&index=0&id=e6a7dff4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__